"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapLayout = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var WrapLayout = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["l-wrap", props.width], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
exports.WrapLayout = WrapLayout;
//# sourceMappingURL=WrapLayout.js.map